/**
 * @group Contact
 * @summary Company email
 * 
 * @remarks
 * This constant contains the company email address used for contact forms,
 * social links, and other communication channels.
 * 
 * @example
 * ```typescript
 * import { COMPANY_EMAIL } from '@shared/constants';
 * 
 * const mailtoLink = `mailto:${COMPANY_EMAIL}`;
 * ```
 */
export const COMPANY_EMAIL = "help@domain.co.za"; 